// export enum AssessmentQuestionType {
//   MultipleChoice = "MultipleChoice",
//   TextInput = "TextInput",
//   FileUpload = "FileUpload"
// }
export enum AssessmentQuestionType {
  TEXT = 0,
  FILE_UPLOAD = 1,
  MULTIPLE_CHOICE = 2,
  SINGLE_CHOICE = 3,
}

interface Choice {
  text: string,
  chosen: boolean,
}

export interface MultipleChoiceQuestion {
  id: number,
  type: AssessmentQuestionType.MULTIPLE_CHOICE,
  description: string,
  answer: {
    [choice_id: number]: Choice
  },
  answerId: number | undefined,
  maxGrade: number,
  hasQuestionFile: boolean,
}


export interface TextInputQuestion {
  id: number,
  type: AssessmentQuestionType.TEXT,
  description: string,
  answer: string,
  answerId: number | undefined,
  maxGrade: number,
  hasQuestionFile: boolean,
}


export interface FileUploadQuestion {
  id: number,
  type: AssessmentQuestionType.FILE_UPLOAD,
  description: string
  answer: string,
  answerId: number | undefined,
  maxGrade: number,
  hasQuestionFile: boolean,
}

export interface SingleChoiceQuestion {
  id: number,
  type: AssessmentQuestionType.SINGLE_CHOICE,
  description: string,
  answer: {
    [choice_id: number]: Choice
  },
  answerId: number | undefined,
  maxGrade: number,
  hasQuestionFile: boolean,
}

export type AssessmentQuestion = MultipleChoiceQuestion | TextInputQuestion | FileUploadQuestion | SingleChoiceQuestion;

